import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function About() {
  return (
    <section
      id="ueber-mich"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-bone-100"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative">
          <div className="absolute -inset-5 bg-honey-100 rounded-[2.5rem] rotate-2" />
          <img
            src="/images/xenia-portrait.jpg"
            alt="Xenia Höfel"
            data-testid="about-image"
            style={{ objectPosition: "center top" }}
            className="relative rounded-[2rem] w-full h-[500px] object-cover shadow-lift"
          />
        </div>

        <div className="lg:col-span-7">
          <span className="font-mono-fine text-[11px] tracking-[0.28em] uppercase text-sage-600">
            Über mich
          </span>
          <h2 className="mt-4 font-display font-light text-4xl md:text-5xl lg:text-[3.5rem] leading-[1.02] tracking-[-0.03em] text-ink-900">
            Was mich zu dem gebracht hat, <span className="italic font-normal">was ich heute mache:</span>.
          </h2>
          <div className="mt-8 space-y-5 text-ink-700 text-[16px] leading-[1.75] max-w-xl">
            <p>
             Schon als Kind hatte ich mit gesundheitlichen Themen zu tun: Hautprobleme, Allergien und ständige Krankheiten haben mich früh begleitet. Vieles wurde nur oberflächlich behandelt und irgendwann hieß es oft, man müsse einfach damit leben. Doch tief in mir hatte ich immer das Gefühl, dass es mehr geben muss als Symptome einfach zu akzeptieren. Dadurch entstand mein Wunsch, den Körper ganzheitlicher zu verstehen.
            </p>
            <p>
              Als ich Mama wurde, wurde diese Suche durch die Beschwerden meines Sohnes noch intensiver. Sie führte mich schließlich zu Anthony William (Medical Medium) – und veränderte meine Sicht auf Gesundheit, Ernährung und Wohlbefinden nachhaltig.
            </p>
            <p>
              Parallel dazu habe ich beim Aufbau meiner Selbstständigkeit erlebt, wie wichtig ein anderes Thema ist: Finanzen. Nicht nur im Sinne von Geld, sondern im Sinne von Klarheit, Struktur und Sicherheit.Parallel dazu habe ich beim Aufbau meiner Selbstständigkeit erlebt, wie wichtig ein anderes Thema ist: Finanzen. Nicht nur im Sinne von Geld, sondern im Sinne von Klarheit, Struktur und Sicherheit.
            </p>
            <p>
             Heute begleite ich Menschen in beiden Bereichen – ruhig, verständlich und Schritt für Schritt.
            </p>
          </div>
          <Link
            to="/ueber-mich"
            className="mt-10 inline-flex items-center gap-2 text-[14px] tracking-wide text-ink-900 link-underline"
          >
            Mehr über mich
            <ArrowUpRight strokeWidth={1.5} className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
